
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["mx-auto",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.989 24.82c.005-.165.011-.337.011-.51 0-5.658-4.704-10.242-10.5-10.242-5.801 0-10.5 4.59-10.5 10.243 0 .172.006.338.011.51M10.52 10.97c2.856 0 5.17-2.456 5.17-5.485C15.69 2.455 13.377 0 10.52 0S5.35 2.456 5.35 5.485c0 3.03 2.314 5.485 5.17 5.485z","fill":"#000"}})])
          )
        }
      }
    